class ProductCollectionClickHandler extends GlobalEventHandler {

    overrideHandle_ClickTemplate(event) {
        // Gender is a locale-invariant view-state emitted by Liquid from
        // collection.metafields.custom.gender onto product cards as
        // data-collection-gender. Read that instead of parsing the URL path
        // (which broke under translated / localised collection handles).
        const card = document.querySelector('.card-gallery[data-collection-gender]');
        const gender = card && card.getAttribute('data-collection-gender');

        if (gender === 'mens') {
            localStorage.setItem("collection-type", "type-men-collection");
        } else if (gender === 'womens') {
            localStorage.setItem("collection-type", "type-women-collection");
        }
    }
}

new ProductCollectionClickHandler();
